<script>
  export let Router, routes;
  import "../public/tailwind.css";
</script>

<svelte:component this={Router} {routes} />
